import { Mapper } from '../base-mapper';
import { OWASReport } from '@/core/domain/owas-report/owas-report';
import { OWASReportDTO } from '@/core/dto/owas-report/owas-report';

export class GetOWASReportMapper implements Mapper<OWASReport> {
	private readonly id: string;
	private readonly name: string;
	private readonly men_exposed: number;
	private readonly women_exposed: number;
	private readonly other_exposed: number;
	private readonly capture_interval_seconds: number;
	private readonly activity_description: string;
	private readonly evaluator_id: string;
	private readonly sector_id: string;
	private readonly line_id: string;
	private readonly workstation_id: string;
	private readonly activity_id: string;
	private readonly analysis_date: string;
	private readonly collection_date: string;
	private readonly current_step: number;
	private readonly is_consolidated: boolean;
	private readonly comment: string | null;
	private readonly original_name: string | null;

	constructor({
		id,
		name,
		men_exposed,
		women_exposed,
		other_exposed,
		capture_interval_seconds,
		activity_description,
		evaluator_id,
		sector_id,
		line_id,
		workstation_id,
		activity_id,
		analysis_date,
		collection_date,
		current_step,
		is_consolidated,
		comment,
		original_name
	}: OWASReportDTO) {
		this.id = id;
		this.name = name;
		this.men_exposed = men_exposed;
		this.women_exposed = women_exposed;
		this.other_exposed = other_exposed;
		this.capture_interval_seconds = capture_interval_seconds;
		this.activity_description = activity_description;
		this.evaluator_id = evaluator_id;
		this.sector_id = sector_id;
		this.line_id = line_id;
		this.workstation_id = workstation_id;
		this.activity_id = activity_id;
		this.analysis_date = analysis_date;
		this.collection_date = collection_date;
		this.current_step = current_step;
		this.is_consolidated = is_consolidated;
		this.comment = comment;
		this.original_name = original_name;
	}

	toDomain(): OWASReport {
		return new OWASReport({
			id: this.id,
			report_name: this.name,
			comment: this.comment ?? '',
			men_exposed: this.men_exposed ?? 0,
			women_exposed: this.women_exposed ?? 0,
			other_exposed: this.other_exposed ?? 0,
			capture_interval_seconds: this.capture_interval_seconds,
			activity_description: this.activity_description,
			evaluator_id: this.evaluator_id,
			sector_id: this.sector_id,
			line_id: this.line_id,
			workstation_id: this.workstation_id,
			activity_id: this.activity_id,
			analysis_date: this.analysis_date,
			collection_date: this.collection_date,
			current_step: Number(this.current_step),
			is_consolidated: this.is_consolidated,
			original_name: this.original_name
		});
	}
}
